import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBack from "@mui/icons-material/ArrowBack";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import { useAlert } from "../../../context/AlertContext";
import "../Login/login.css";

const ResetPassword = () => {
  const navigate = useNavigate();
  const { guid } = useParams();
  const { showAlert } = useAlert();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [confirmError, setConfirmError] = useState("");
  const [loading, setLoading] = useState(false);

  const passwordValid = password.length >= 8;
  const passwordsMatch = confirmPassword.length > 0 && confirmPassword === password;
  const formValid = passwordValid && passwordsMatch;

  const handleSubmit = async (e) => {
    e.preventDefault();

    setPasswordError("");
    setConfirmError("");

    if (!passwordValid) {
      setPasswordError("Lozinka mora imati najmanje 8 karaktera");
      return;
    }
    if (!passwordsMatch) {
      setConfirmError("Lozinke se ne poklapaju");
      return;
    }

    setLoading(true);
    try {
      await ApiMethods.post("auth/forgot-password", { guid, password });
      navigate("/password-updated");
    } catch (error) {
      showAlert("Greška pri resetovanju lozinke", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="hf-login-root">
      <div className="hf-login-shell">
        <div className="hf-login-brand">
          <img
            className="hf-login-brand-logo"
            src="/img/hitfitlogo.jpg"
            alt="HitFit"
          />
          <h2 className="hf-login-brand-heading">
            Vođeni treninzi za rekreativce
          </h2>
        </div>

        <div className="hf-login-card">
          <div className="hf-login-card-inner">
            <div className="hf-login-logo-wrap">
              <img
                className="hf-login-logo"
                src="/img/hitfitlogo.jpg"
                alt="HitFit"
              />
            </div>

            <button
              type="button"
              className="hf-login-back"
              aria-label="Nazad na prijavu"
              onClick={() => navigate("/login")}
            >
              <ArrowBack fontSize="small" />
            </button>

            <h1 className="hf-login-title">Resetuj lozinku</h1>
            <p className="hf-login-subtitle">
              Napravite novu, sigurnu lozinku za svoj nalog.
            </p>

            <form className="hf-login-form" onSubmit={handleSubmit}>
              <div className="hf-login-field">
                <label className="hf-login-label" htmlFor="rp-password">
                  Nova lozinka
                </label>
                <div
                  className={`hf-login-input-wrap${passwordError ? " hf-login-input-error" : ""}`}
                >
                  <span className="hf-login-input-icon">
                    <LockOutlinedIcon fontSize="small" />
                  </span>
                  <input
                    id="rp-password"
                    name="rp-password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Unesite novu lozinku"
                    autoComplete="new-password"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setPasswordError("");
                    }}
                    required
                  />
                  <button
                    type="button"
                    className="hf-login-toggle-visibility"
                    aria-label={showPassword ? "Sakrij lozinku" : "Prikaži lozinku"}
                    onClick={() => setShowPassword((v) => !v)}
                  >
                    {showPassword ? (
                      <VisibilityOff fontSize="small" />
                    ) : (
                      <Visibility fontSize="small" />
                    )}
                  </button>
                </div>
                {passwordError ? (
                  <p className="hf-login-error-text">{passwordError}</p>
                ) : (
                  <p className="hf-login-hint">Najmanje 8 karaktera.</p>
                )}
              </div>

              <div className="hf-login-field">
                <label className="hf-login-label" htmlFor="rp-password2">
                  Potvrdi lozinku
                </label>
                <div
                  className={`hf-login-input-wrap${confirmError ? " hf-login-input-error" : ""}`}
                >
                  <span className="hf-login-input-icon">
                    <LockOutlinedIcon fontSize="small" />
                  </span>
                  <input
                    id="rp-password2"
                    name="rp-password2"
                    type={showPassword ? "text" : "password"}
                    placeholder="Ponovo unesite lozinku"
                    autoComplete="new-password"
                    value={confirmPassword}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      setConfirmError("");
                    }}
                    required
                  />
                </div>
                {confirmError && (
                  <p className="hf-login-error-text">{confirmError}</p>
                )}
              </div>

              <button
                type="submit"
                className="hf-login-submit"
                disabled={!formValid || loading}
              >
                {loading ? "Ažuriranje..." : "Resetuj lozinku"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
